import {FunctionComponent, SVGProps} from 'react'
import access from './access.svg?react'
import access_pieton from './accessPieton.svg?react'
import add from './add.svg?react'
import aiguillage from './aiguillage.svg?react'
import client from './client.svg?react'
import colorPicker from './color-picker.svg?react'
import deleteSvg from './delete.svg?react'
import mail from './mail.svg?react'
import download_pdf from './download_pdf.svg?react'
import errors from './errors.svg?react'
import exclamation from './exclamation.svg?react'
import eye from './eye.svg?react'
import eye_closed from './eye_close.svg?react'
import eye_open from './eye_open.svg?react'
import history from './history.svg?react'
import info from './info.svg?react'
import left_arrow from './left_arrow.svg?react'
import logout from './logout.svg?react'
import openCloseArrow from './openCloseArrow.svg?react'
import passage_niveau from './access.svg?react'
import projectSetting from './projectSetting.svg?react'
import right_arrow from './right_arrow.svg?react'
import safeArea from './safeArea.svg?react'
import shift_day from './shift_day.svg?react'
import shift_night from './shift_night.svg?react'
import shift_both from './shift_both.svg?react'
import protection from './protection.svg?react'
import sortie_secours from './sortieSecours.svg?react'
import switchDouble from './switchDouble.svg?react'
import switchSimple1 from './switchSimple1.svg?react'
import switchSimple2 from './switchSimple2.svg?react'
import switchStraight from './switchStraight.svg?react'
import team from './team.svg?react'
import user from './user.svg?react'
import revert from './revert.svg?react'
import cross from './cross.svg?react'
import minus from './minus.svg?react'
import more from './more.svg?react'
import movement from './movement.svg?react'
import train_station_hour from './train-station-hour.svg?react'
import calendarPeriod from './calendarPeriod.svg?react'
import calendarMonth from './calendarMonth.svg?react'
import calendarWeek from './calendarWeek.svg?react'
import calendarToday from './calendarToday.svg?react'
import cancelled from './cancelled.svg?react'
import book from './book.svg?react'
import search from './search.svg?react'
import filter from './filter.svg?react'
import allTracks from './allTracks.svg?react'
import conflict from './conflict.svg?react'
import conflict_allowed from './conflict_allowed.svg?react'
import work from './work.svg?react'
import movements from './movement.svg?react'
import railroad from './railroad.svg?react'
import rocket from './rocket.svg?react'
import hours24 from './24hours.svg?react'
import train_filled from './train_filled.svg?react'
import eclair from './eclair.svg?react'
import rail from './rail.svg?react'
import magic from './magic.svg?react'
import building from './building.svg?react'
import fence from './fence.svg?react'
import protection_access from './protection_access.svg?react'
import protection_general from './protection_general.svg?react'
import protection_mechanical from './protection_mechanical.svg?react'
import protection_pneumatic from './protection_pneumatic.svg?react'
import entry from './entry.svg?react'
import sectors from './sectors.svg?react'
import subSectors from './subSectors.svg?react'
import update from './update.svg?react'
import notice from './noticeIcon.svg?react'
import activity from './activityIcon.svg?react'
import aiguillageColor from './aiguillageColor.svg?react'
import approve from './check.svg?react'
import inprogress from './current.svg?react'
import helmet from './helmet.svg?react'
import swap from './swap.svg?react'
import worker from './worker.svg?react'
import print from './print.svg?react'
import badge from './badge.svg?react'
import hierarchy from './hierarchy.svg?react'
import person from './person.svg?react'
import clock from './clock.svg?react'
import chart from './chart.svg?react'
import wand from './wand.svg?react'
import checklist from './checklist.svg?react'
import location from './location.svg?react'
import synoptic from './synoptic.svg?react'

const ImageSvgIcon = {
  logout,
  add,
  left_arrow,
  right_arrow,
  errors,
  openCloseArrow,
  shift_day,
  shift_night,
  shift_both,
  delete: deleteSvg,
  mail,
  revert,
  update,
  history,
  download_pdf,
  access_pieton,
  passage_niveau,
  sortie_secours,
  access,
  aiguillage,
  info,
  projectSetting,
  safeArea,
  team,
  colorPicker,
  switchSimple1,
  switchSimple2,
  switchDouble,
  switchStraight,
  client,
  exclamation,
  eye,
  eye_closed,
  eye_open,
  user,
  cross,
  minus,
  more,
  movement,
  train_station_hour,
  calendarMonth,
  calendarToday,
  cancelled,
  book,
  search,
  filter,
  allTracks,
  conflict,
  conflict_allowed,
  work,
  movements,
  railroad,
  rocket,
  calendarWeek,
  hours24,
  train_filled,
  protection,
  eclair,
  rail,
  magic,
  building,
  fence,
  protection_access,
  protection_general,
  protection_mechanical,
  protection_pneumatic,
  entry,
  sectors,
  subSectors,
  notice,
  activity,
  aiguillageColor,
  approve,
  inprogress,
  helmet,
  swap,
  worker,
  print,
  badge,
  hierarchy,
  person,
  clock,
  chart,
  checklist,
  location,
  synoptic,
  calendarPeriod,
  wand,
} satisfies Record<
  string,
  FunctionComponent<SVGProps<SVGSVGElement> & {title?: string | undefined}>
>

export default ImageSvgIcon
